module.exports = __webpack_public_path__ + "img/logo.100edf77.png";